import { render, staticRenderFns } from "./meal.vue?vue&type=template&id=305e09b1&scoped=true&"
import script from "./meal.vue?vue&type=script&lang=js&"
export * from "./meal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e09b1",
  null
  
)

export default component.exports